module.exports = __webpack_public_path__ + "img/promo_logo02.35cd2dd6.png";